export default "__VITE_ASSET__ybqEVwuB__"